import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';

import { AppComponent } from 'src/app/app.component';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';

import { AdditionalInvestmentService } from 'src/app/_services/additional-investment.service';
import { AdminService } from 'src/app/_services/admin.service';
import { AuditLogService } from 'src/app/_services/audit-log.service';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { ConfigService } from 'src/app/_services/config.service';
import { ConfigServiceInitializer } from 'src/app/_services/config.service.initializer';
import { FlyOverService } from 'src/app/_services/fly-over.service';
import { GemstoneService } from 'src/app/_services/gemstone.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { NotificationService } from 'src/app/_services/notification.service';
import { RolesService } from 'src/app/_services/roles.service';
import { ServiceAdminService } from 'src/app/_services/service-admin.service';
import { SessionStorageService } from 'src/app/_services/session-storage.service';
import { SwitchService } from 'src/app/_services/switch.service';
import { DocumentService } from 'src/app/_services/document.service';
import { UserService } from 'src/app/_services/user.service';
import { UserAdminService } from 'src/app/_services/user-admin.service';
import { ServiceNewsService } from 'src/app/_services/service-news.service';
import { FeeUploadService } from 'src/app/_services/fee-upload.services';
import { LoaderService } from 'src/app/_services/loader.service';
import { DigiVideoService } from './_services/digi-video.service';
import { MAT_DATE_LOCALE } from '@angular/material/core'

// guards
import { AuthGuard } from 'src/app/_guards';

// interceptors
import { ErrorInterceptor } from 'src/app/_interceptors/error.interceptor';
import { RequestInterceptor } from 'src/app/_interceptors/request.interceptor';

// directives
import { NavbarComponent } from 'src/app/navbar/navbar.component';
import { NoWhiteSpaceDirective } from 'src/app/_directives/no-white-space.component';
import { WebIdMaskingDirective } from 'src/app/_directives/webId.mask.component';

// filters
import { UserFilterPipe } from 'src/app/_filters/user-filter.pipe';

// Dialogs
import { AddAdminUserDialogComponent } from 'src/app/_modals/add-admin-user-dialog/add-admin-user-dialog.component';
import { EditDocumentsDocumentDialogComponent } from 'src/app/_modals/edit-documents-document-dialog/edit-documents-document-dialog.component';
import { AddComponentDialogComponent } from 'src/app/_modals/add-component-dialog/add-component-dialog.component';
import { AddUserDialogComponent } from 'src/app/_modals/add-user-dialog/add-user-dialog.component';
import { EditUserDialogComponent } from 'src/app/_modals/edit-user-dialog/edit-user-dialog.component';
import { CheckWebIdDialogComponent } from 'src/app/_modals/check-webid/check-webid.component';
import { ConfirmationDialogComponent } from 'src/app/_modals/confirmation-dialog/confirm-dialog.component';
import { EmailConfirmDialogComponent } from 'src/app/_modals/email-confirm/email-confirm.component';
import { SetUserPasswordDialogComponent } from 'src/app/_modals/set-user-password/set-user-password.component';
import { AddNewsDialogComponent } from 'src/app/_modals/add-news-dialog/add-news-dialog.component';
import { RichTextEditorAllModule } from '@syncfusion/ej2-angular-richtexteditor';
import { UploadFileDialogComponent } from './_modals/upload-file-dialog/upload-file-dialog.component';
import { AddVideoDialogComponent } from './_modals/add-video-dialog/add-video-dialog.component';

@NgModule({
    imports: [
        AppRoutingModule,
        BrowserAnimationsModule,
        SharedModule,
        RichTextEditorAllModule
    ],
    declarations: [
        AddAdminUserDialogComponent,
        EditDocumentsDocumentDialogComponent,
        AddComponentDialogComponent,
        AddUserDialogComponent,
        EditUserDialogComponent,
        AppComponent,
        CheckWebIdDialogComponent,
        ConfirmationDialogComponent,
        EmailConfirmDialogComponent,
        NavbarComponent,
        NoWhiteSpaceDirective,
        SetUserPasswordDialogComponent,
        UploadFileDialogComponent,
        UserFilterPipe,
        WebIdMaskingDirective,
        AddNewsDialogComponent,
        AddVideoDialogComponent
    ],
    providers: [
        AdditionalInvestmentService,
        AdminService,
        AuditLogService,
        AuthenticationService,
        AuthGuard,
        ConfigService,
        ConfigServiceInitializer,
        FeeUploadService,
        FlyOverService,
        GemstoneService,
        LoaderService,
        LocalStorageService,
        NotificationService,
        RolesService,
        ServiceAdminService,
        ServiceNewsService,
        SessionStorageService,
        SwitchService,
        DocumentService,
        UserService,
        UserAdminService,
        DigiVideoService,
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true },
        { provide: MAT_DATE_LOCALE, useValue: 'en-ZA' }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
